{
  "meta": {
    "title": "AmberBytes — Software Craftsmen",
    "description": "AmberBytes builds fast, reliable, and human-centered software for ambitious teams."
  },
  "nav": {
    "services": "Services",
    "about": "About",
    "tech": "Tech",
    "contact": "Contact"
  },
  "hero": {
    "headline": "We turn rough ideas into polished software.",
    "subheadline": "AmberBytes is a tight-knit tech consultancy that designs, builds, and ships digital products with clarity and speed.",
    "cta": "Start a project"
  },
  "services": {
    "title": "What we do",
    "subtitle": "End-to-end product expertise, from first sketch to production scale.",
    "items": [
      {
        "title": "Product Strategy",
        "description": "We help you find the signal in the noise and define a product your users will love."
      },
      {
        "title": "Web Applications",
        "description": "Modern, accessible, and performant frontends built with React, TypeScript, and Tailwind."
      },
      {
        "title": "Backend Systems",
        "description": "Robust APIs, cloud infrastructure, and data pipelines that scale with your business."
      },
      {
        "title": "Team Augmentation",
        "description": "Senior engineers embedded in your team to accelerate delivery and raise the bar."
      }
    ]
  },
  "about": {
    "title": "Why AmberBytes?",
    "paragraphs": [
      "We believe great software is born from curiosity, discipline, and close collaboration. Every project starts with listening.",
      "Our team has shipped products for startups, scale-ups, and enterprise clients across fintech, healthtech, and digital commerce.",
      "We care about clean architecture, fast feedback loops, and designs that actually work for real people."
    ]
  },
  "tech": {
    "title": "Tools we love",
    "subtitle": "We choose the right stack for the job — here is what we reach for most often."
  },
  "contact": {
    "title": "Let's build something amber.",
    "subtitle": "Tell us what you are working on. We will get back to you within two business days.",
    "name": "Name",
    "email": "Email",
    "message": "Message",
    "send": "Send message",
    "success": "Thanks — we will be in touch soon.",
    "emailLabel": "Or write us directly at"
  },
  "footer": {
    "rights": "© {year} AmberBytes. All rights reserved.",
    "language": "Language"
  }
}
